import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import es from "./locales/es.json";

i18n
  .use(initReactI18next)  
  .init({
    debug: true,
    resources: {
      en: en,
      es: es,
    },
    lng: "es", // Default language
    ns: ["index", "cedulas", "allPages", "email"], // Include all namespaces
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;